import { REQUEST_RESPONSE_LOGS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Request_Response_Logs = (payload) => {
  return apiInstance.post(REQUEST_RESPONSE_LOGS, payload);
};
